import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import MuiChip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import chatbot from '../images/chatbot2.png';
import humanobot from '../images/humanobot.png';
import fluxoIa from '../images/fluxo-ia.png';
import atendvirtual from '../images/atendvirt.svg';

import AutomationIcon from '@mui/icons-material/SmartToy';
import SupportIcon from '@mui/icons-material/Support';
import IntegrationHubIcon from '@mui/icons-material/Hub';

const items = [
  {
    icon: <AutomationIcon />,
    title: 'Atendimento Automatizado',
    description:
      'Automatize seu atendimento no WhatsApp com respostas instantâneas 24/7. Aumente sua eficiência e nunca mais perca um cliente por demora no atendimento.',
    // image: chatbot,
  },
  {
    icon: <SupportIcon />,
    title: 'Suporte Personalizado',
    description:
      'Atendimento com inteligência artificial que se adapta às necessidades dos seus clientes de forma única e humanizada.',
    // image: humanobot,
  },
  {
    icon: <IntegrationHubIcon />,
    title: 'Integração Completa',
    description:
      'Integre com suas ferramentas favoritas. Capture leads, agende compromissos e gerencie pedidos, tudo automaticamente através do WhatsApp.',
    // image: fluxoIa,
  },
];

interface ChipProps {
  selected?: boolean;
}

const Chip = styled(MuiChip)<ChipProps>(({ theme }: any) => ({
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        background:
          'linear-gradient(to bottom right, hsl(210, 98%, 48%), hsl(210, 98%, 35%))',
        color: 'hsl(0, 0%, 100%)',
        borderColor: (theme.vars || theme).palette.primary.light,
        '& .MuiChip-label': {
          color: 'hsl(0, 0%, 100%)',
        },
        ...theme.applyStyles('dark', {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

interface MobileLayoutProps {
  selectedItemIndex: number;
  handleItemClick: (index: number) => void;
  selectedFeature: (typeof items)[0];
}

export function MobileLayout({
  selectedItemIndex,
  handleItemClick,
  selectedFeature,
}: MobileLayoutProps) {
  if (!items[selectedItemIndex]) {
    return null;
  }

  return (
    <Box
      sx={{
        display: { xs: 'flex', sm: 'none' },
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, overflow: 'auto' }}>
        {items.map(({ title }, index) => (
          <Chip
            size="medium"
            key={index}
            label={title}
            onClick={() => handleItemClick(index)}
            selected={selectedItemIndex === index}
          />
        ))}
      </Box>
      <Card variant="outlined">
        <Box sx={{ px: 2, pb: 2, pt: 3 }}>
          <Typography
            gutterBottom
            sx={{ color: 'text.primary', fontWeight: 'medium' }}
          >
            {selectedFeature.title}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
            {selectedFeature.description}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
}

export default function Features() {

  return (
    <Container
      id="features"
      sx={{
        py: { xs: 8, sm: 16 },
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' },
          alignSelf: 'center',
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
        >
          Recursos Poderosos
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: 'text.secondary', mb: { xs: 2, sm: 4 } }}
        >
          Descubra como a Nextalk pode transformar seu atendimento no WhatsApp
          e impulsionar seus resultados com recursos avançados e fáceis de usar.
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row-reverse' },
          gap: 2,
          // border: '1px solid',
        }}
      >
        <div>
          <Box
            sx={{
              // display: { xs: 'none', sm: 'flex' },
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: 0, sm: 2 },
              height: '100%',
              // border: '1px solid',
            }}
          >
            {items.map(({ icon, title, description }, index) => (
              <Box
                key={index}
                component={Button}
                // onClick={() => handleItemClick(index)}
                sx={[
                  (theme: any) => ({
                    p: 2,
                    height: '100%',
                    width: '100%',
                    '&:hover': {
                      backgroundColor: (theme.vars || theme).palette.action.hover,
                    },
                  }),
                  // selectedItemIndex === index && {
                  //   backgroundColor: 'action.selected',
                  // },
                ]}
              >
                <Box
                  sx={[
                    {
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'left',
                      gap: 1,
                      textAlign: 'left',
                      textTransform: 'none',
                      // color: 'text.secondary',
                    },
                    // selectedItemIndex === index && {
                    //   color: 'text.primary',
                    // },
                  ]}
                >
                  <Box color="text.primary">{icon}</Box>
                  <Typography variant="h6" color="text.primary">{title}</Typography>
                  <Typography variant="body2" color="text.secondary">{description}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
          {/* <MobileLayout
            selectedItemIndex={selectedItemIndex}
            handleItemClick={handleItemClick}
            selectedFeature={selectedFeature}
          /> */}
        </div>
        <Box
          sx={{
            // display: { xs: 'none', sm: 'flex' },
            display: 'flex',
            alignSelf: 'center',
            width: { xs: '100%',  md: '70%' },
            height: { xs: '50vh', sm: 500 },
            // height: 500,
            mt: { xs: 5, md: 0 },
            // mb : { xs: 5, sm: 0 },
            // border: '1px solid',
            // height: 'var(--items-image-height)',
          }}
        >
          {/* <Card
            variant="outlined"
            sx={{
              height: '100%',
              width: '100%',
              display: { xs: 'none', sm: 'flex' },
              pointerEvents: 'none',
            }}
          > */}
            <Box
              sx={{
                width: '100%',
                height: '100%',
                borderRadius: '5px',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                // backgroundImage: `url(${items[selectedItemIndex].image})`,
                backgroundImage: `url(${atendvirtual})`,
                // border:'1px solid',
                // mt: { xs: 5, md: 0 },
              }}
            />
          {/* </Card> */}
        </Box>
      </Box>
    </Container>
  );
}